<template>
  <td class="d-block d-sm-table-cell d-print-table-cell align-center">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="$emit('view', item)">
          mdi-eye
        </v-icon>
      </template>
      <span>View Merchant</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="$emit('edit', item)">
          mdi-pencil
        </v-icon>
      </template>
      <span>Edit Merchant</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          class="mr-2"
          v-bind="attrs"
          v-on="on"
          v-if="!isDisabledBlock && (item.status === 'active' || item.status === 'blocked')"
          @click="$emit('blockUnblock', item)"
        >
          {{ getActionIcon(item.status) }}
        </v-icon>
      </template>
      <span>{{ getActionLabel(item.status) }}</span>
    </v-tooltip>
  </td>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    isDisabledBlock: Boolean,
    getActionIcon: {
      type: Function,
      default: () => () => ''
    },
    getActionLabel: {
      type: Function,
      default: () => () => ''
    }
  }
};
</script>
